<script lang="ts">
    import { onDestroy } from 'svelte';
    import { getCometDContext } from './cometd.store';
    import { page } from '$app/stores';
    import { subscribeToCometDPlayerChannelEvents } from '$src/lib/services/gatekeeper/cometd/getCometdPlayerEventsMessagebusSubscriptions';

    const cometd = getCometDContext();
    let unsubscribeFromCometDPlayerChannelEvents: () => void | undefined;

    $: {
        // Unsubscribe before re-subscribing
        if (unsubscribeFromCometDPlayerChannelEvents) unsubscribeFromCometDPlayerChannelEvents();

        // Create a new subscription
        unsubscribeFromCometDPlayerChannelEvents = subscribeToCometDPlayerChannelEvents(
            $cometd,
            $page.data.player,
            $page.data.sessionId
        );
    }

    onDestroy(() => {
        if (unsubscribeFromCometDPlayerChannelEvents) unsubscribeFromCometDPlayerChannelEvents();
    });
</script>
